import { encodeQueryData } from 'utils/Helpers'
import { GOOGLE_API_KEY } from 'constants/ResourcesConstants'

export function fetchTimeZone(lat, lng) {
  const query = {
    location: `${lat},${lng}`,
    timestamp: Math.floor(new Date().getTime() / 1000),
    key: GOOGLE_API_KEY
  }

  const request = fetch(`https://maps.googleapis.com/maps/api/timezone/json?${encodeQueryData(query)}`, {
    method: 'GET'
  })
  return request.then(res => {
    if (res.ok) {
      return res.json()
    } else {
      throw new Error('Failed to get timezone from google')
    }
  })
}



// WEBPACK FOOTER //
// ./src/scripts/app/api/TimeZoneAPI.js